import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { DevicesOsUpdateStatesEffects } from './devices-os-update-status.effects';
import { DevicesOsUpdateStatesFeatureKey, DevicesOsUpdateStatesReducer } from './devices-os-update-status.reducer';

export const provideDevicesOsUpdateStatusStore = () => [
  provideState(DevicesOsUpdateStatesFeatureKey, DevicesOsUpdateStatesReducer),
  provideEffects([DevicesOsUpdateStatesEffects]),
];
